/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Selbstverplichtungserklaerungerhalten1Inputs */

const de__field_selbstverplichtungserklaerungerhalten1 = /** @type {(inputs: _Field_Selbstverplichtungserklaerungerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selbstverpflichtungserklärung erhalten`)
};

/**

* @param {_Field_Selbstverplichtungserklaerungerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_selbstverplichtungserklaerungerhalten1 = /** @type {((inputs?: _Field_Selbstverplichtungserklaerungerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Selbstverplichtungserklaerungerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_selbstverplichtungserklaerungerhalten1(inputs)
});
export { _field_selbstverplichtungserklaerungerhalten1 as "_field_selbstverplichtungserklaerungErhalten" }